import { AssetsState } from './state';

export const assetsInitialState: AssetsState = {
    assets: {},
    statuses: {}
}